<template>
    <b-modal v-model="showModal" size="xl" @hidden="cancelar" button-size="md" hide-footer :title="prefix + title">
        <ItemBemPermanenteList :isAbertoFromModal="true" :podeMudarDepartamento="podeMudarDepartamento" @onDblClickItemBemPermanente="selecionarItem" :id="id" :prefix="prefix + title">
        </ItemBemPermanenteList>

        <b-form-row>
            <div class="col-6"></div>
            <b-button id="cancelarModalIBP" pill style="height: 30px" @click="cancelar" size="sm" variant="danger">
                <div class="btn-size-alinhamento">
                    <b-icon icon="x-circle" />
                </div>
                <b-tooltip target="cancelarModalIBP" title="Cancelar"></b-tooltip>
            </b-button>

        </b-form-row>
    </b-modal>
</template>

<script>

import ItemBemPermanenteList from '@/modules/patrimonio/item-bem-permanente/ItemBemPermanenteList.vue';

export default {
    name: "ModalPageItemBemPermanente",
    components: {
        ItemBemPermanenteList,

    },
    props: {
        id: Number,
        podeMudarDepartamento:{type:Boolean, default: false},
        title: { type: String, default: "Item Bem Permanente" },
        prefix: { type: String, default: "" },
    },
    data() {
        return {
            showModal: true,

        }
    },
    methods: {
        selecionarItem(item) {
            this.showModal = false;
            this.$emit('onselect', item);

        },
        cancelar() {
            this.showModal = false;
            this.$emit('fecharModal');
        },

    }
}

</script>
